module.exports = "/DesktopModules/Cantarus/StencilDisplay/Clients/assets/cc_icon_refresh.svg";